var domain_backend = "https://wedding.dientrang.love/api";
// domain_backend = "http://localhost:8000/api";

export { domain_backend }